// Vuelidate 2 has no validation groups (vuelidate 0.7 did). This mixin rebuilds them
// from the component's `groups` data (group name -> list of `fields.x` paths) and
// `sections`, exposing `vGroups[name]` and `vForms.section` with $invalid, $error and $touch().
const resolve = (root, path) => path.split('.').reduce((o, k) => o[k], root);

const combine = items => ({
    get $invalid() {
        return items.some(i => i.$invalid);
    },
    get $error() {
        return items.some(i => i.$error);
    },
    $touch: () => items.forEach(i => i.$touch())
});

export default {
    computed: {
        vGroups() {
            const groups = {};
            Object.keys(this.groups).forEach(name => {
                groups[name] = combine(
                    this.groups[name].map(path => resolve(this.v$, path))
                );
            });
            return groups;
        },
        vForms() {
            return {
                section: combine(
                    this.sections.map(s => this.vGroups[s]).filter(Boolean)
                )
            };
        }
    }
};
